import { GoogleFont, GoogleFontVariant } from '../components/styles/fieldsets/FontFieldset.js'
import { Style } from '@sitecore-feaas/sdk'

export const extractFontWeight = (variant: string): number => {
  let variantWeight = variant.match(/\d+/g)
  return (variantWeight?.length && parseInt(variantWeight[0])) ?? 400
}

export const extractFontStyle = (variant: string): Style.Font.VariantStyle => {
  let variantStyle = variant.match(/[a-zA-Z]+/g)
  let variantStyleParsed = (variantStyle?.length && variantStyle[0]) ?? 'normal'
  if (variantStyleParsed === 'regular') variantStyleParsed = 'normal'

  return variantStyleParsed as Style.Font.VariantStyle
}

export const parseGoogleFont = (font: GoogleFont): Style.Font.Props => {
  return {
    familyName: font.family,
    variants: parseGoogleFontVariants(font),
    platform: Style.Font.Platform.google
  }
}

export const parseGoogleFontVariants = (font: GoogleFont): Style.Font.Variant[] => {
  if (!font) return []

  return font.variants.map((variant: GoogleFontVariant) => {
    return {
      name: variant,
      style: extractFontStyle(variant),
      weight: extractFontWeight(variant),
      familyName: font.family
    }
  })
}
